import Vue from 'vue'
import VueRouter from 'vue-router'

// import deltaPlugins from '../deltaPlugins.js'

import '../quasar.js'

import App from './App.vue'

export function initPage (pageConfig) {
/**
 * Значения генерируются автоматически при сборке.
 * См. в build.gradle task createBuildFile.
 */
  var deltaVersion = '2.0'
  var uiBuildDate = null
  var uiBuildNumber = null

  var titleAdditional = ''
  if (uiBuildDate) {
    titleAdditional = ' UI:' + uiBuildDate
    if (typeof uiBuildNumber == 'number' && uiBuildNumber > 1) {
      titleAdditional += '/' + uiBuildNumber
    }
  }

  var deltaSystemName = 'АС Дельта ' + deltaVersion
  var deltaSystemTitle = deltaSystemName + titleAdditional
  document.title = deltaSystemTitle

  // Vue.use(lodash)
  // Vue.use(deltaPlugins)
  Vue.use(VueRouter)

  // const componentProps = {}
  // if (pageConfig.props) {
  // componentProps.props = pageConfig.props
  // }

  new Vue({
    router: initPageRouter(pageConfig),
    store: pageConfig.store,
    // render: h => h(pageConfig.component, componentProps)
    render: h => h(App)
  }).$mount('#app')
}

function initPageRouter (pageRoute) {
  return new VueRouter({
    mode: 'history',
    routes: [
      pageRoute,
      {
        path: '/',
        beforeEnter: function (to, from, next) {
          window.location.replace('/')
          next()
        }
      }
    ]
  })
}
